import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=c85cf606&scoped=true&"
import script from "./Terms.vue?vue&type=script&lang=ts&"
export * from "./Terms.vue?vue&type=script&lang=ts&"
import style0 from "./Terms.vue?vue&type=style&index=0&id=c85cf606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85cf606",
  null
  
)

export default component.exports